import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.wrapperClasses)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass($options.slotWrapperClasses)
    }, [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ isStuck: _ctx.isStuck })))
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}